import { Share } from '@capacitor/share';
import { isNativeApp } from './runtime';

export interface SpoilerSafeShareItem {
  homeTeamName: string;
  awayTeamName: string;
  sportPath: string;
}

export function buildSpoilerSafeSharePayload(item: SpoilerSafeShareItem) {
  const url = new URL(item.sportPath, 'https://skore.info').toString();
  return {
    title: 'A spoiler-free game pick on skore',
    text: `${item.awayTeamName} vs ${item.homeTeamName} — open without the score.`,
    url,
    dialogTitle: 'Share without spoilers',
  };
}

export async function shareSpoilerSafeItem(item: SpoilerSafeShareItem): Promise<void> {
  const payload = buildSpoilerSafeSharePayload(item);
  if (isNativeApp()) {
    await Share.share(payload);
    return;
  }
  if (navigator.share) {
    await navigator.share(payload);
    return;
  }
  await navigator.clipboard.writeText(`${payload.text} ${payload.url}`);
}

